import React, { useState } from "react";
import styles from "./Testimonial.module.css";
import { Border } from "../maincomps/border/Border";
import { LeftArrow, Leftcomma, RightArrow, Rightcomma, StarIcon } from "../../../Svg";
import { Box } from "@mui/material";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


const Testimonial = ({ testimonials = [] }) => {
    const CustomArrow = ({ className, onClick, arrowDirection }) => {
        return (
            <div
                className={`${className} ${styles.customArrow} ${arrowDirection === "left" ? styles.leftArrow : styles.rightArrow
                    }`}
                onClick={onClick}
            >
                {arrowDirection === "left" ? <LeftArrow /> : <RightArrow />}
            </div>
        );
    };

    if (!testimonials || testimonials?.length === 0) {
        return (
            <div>
                No testimonials found
            </div>
        )
    }
    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 4, // Display 4 products per slide
        slidesToScroll: 1,
        prevArrow: <CustomArrow arrowDirection="left" />,
        nextArrow: <CustomArrow arrowDirection="right" />,
        adaptiveHeight: true,
        autoplay: true, // Enable auto-play
        autoplaySpeed: 2000, // Set auto-play speed in milliseconds (3 seconds)
        pauseOnHover: true, // Pause auto-play on hover
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 546,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 420,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    };

    return (
        <>
            <div className={styles.testimonialcont}>
                <Border title='HAPPY CLIENTS'  />

                <div className={styles.testimonialSlider}>

                    <Slider {...settings} className={styles.slickSlider} style={{ gap: "16px", width: "86%" }}>
                        {testimonials?.image?.map((img) => {
                            return (
                                <div className={styles.productImage}>
                                    <img
                                        src={img}
                                        alt="Img"
                                        
                                    />
                                </div>
                            )
                        })}
                    </Slider>
                </div>
            </div>
        </>
    );
};

export default Testimonial;
